import { InputHTMLAttributes, FC } from 'react';
import { FormControl, FormControlProps, InputGroup } from 'react-bootstrap';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps
} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

export type IconInputProps = Pick<FontAwesomeIconProps, 'icon'> &
  FormControlProps &
  InputHTMLAttributes<HTMLInputElement>;

export const IconInput: FC<IconInputProps> = ({
  className,
  style,
  icon,
  ...control
}) => (
  <InputGroup className={className} style={style}>
    <InputGroup.Text
      className="border-0 bg-dark text-secondary"
      style={{
        borderTopLeftRadius: 12,
        borderBottomLeftRadius: 12,
        padding: 10
      }}
    >
      <FontAwesomeIcon className="fs-20" icon={icon} />
    </InputGroup.Text>
    <FormControl
      className="border-0 ps-0 text-secondary bg-dark"
      style={{ borderTopRightRadius: 12, borderBottomRightRadius: 12 }}
      {...control}
    />
  </InputGroup>
);
